import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'customerAttributeList' satisfies PathKey
